/* global globalThis */
export const PRODUCTION_ORIGIN = "https://www.bowlingtournamentapp.com";

export const SITE_ORIGIN = PRODUCTION_ORIGIN;

export const SUPPORT_EMAIL = "support@bowlingtournamentapp.com";

// Keep this function in this module. Importing it from a CommonJS helper
// made the production bundle call a value that was not a function, and
// DefaultSeo crashed on every page.
export const PRODUCTION_HOSTS = [
  "www.bowlingtournamentapp.com",
  "bowlingtournamentapp.com",
];

export const isIndexableHost = (hostname = "") =>
  PRODUCTION_HOSTS.includes(String(hostname).toLowerCase());

export const DEFAULT_OG_IMAGE = "/og-board.png";

export const DEFAULT_OG_IMAGE_ALT = "Bowling Tournament App";

// Square geometric mark from the BTA-168 favicon set. Organization.logo uses
// this. Open Graph and Twitter stay on DEFAULT_OG_IMAGE.
export const BRAND_MARK_IMAGE = "/favicon-192x192.png";

export const BRAND_MARK_SIZE = 192;

export const brandMarkLogo = (origin = SITE_ORIGIN) => ({
  "@type": "ImageObject",
  url: `${origin}${BRAND_MARK_IMAGE}`,
  width: BRAND_MARK_SIZE,
  height: BRAND_MARK_SIZE,
});

export const isIndexableDeployment = (hostname) => {
  if (
    (hostname == null || hostname === "") &&
    typeof globalThis.__PRERENDER_INDEXABLE__ === "boolean"
  ) {
    return globalThis.__PRERENDER_INDEXABLE__;
  }
  const host =
    hostname ||
    (typeof window !== "undefined" ? window.location.hostname : "");
  return isIndexableHost(host);
};

export const robotsContent = ({
  noIndex = false,
  noFollow = false,
  hostname,
} = {}) => {
  const indexable = isIndexableDeployment(hostname);
  const index = indexable && !noIndex ? "index" : "noindex";
  const follow = indexable && !noFollow ? "follow" : "nofollow";
  return `${index}, ${follow}`;
};
